<template>
  <nav
    class="navbar navbar-expand navbar-dark position-relative"
    style="z-index: 1; background: #272727 !important"
  >
    <div class="container">
      <div class="navbar-header">
        <router-link class="navbar-brand" to="/" style="color: #fff !important"
          >PushMyROI</router-link
        >
      </div>
      <ul class="nav navbar-nav">
        <router-link
          v-if="!isLoggedIn"
          class="nav-item nav-link underlineHover"
          :to="{ name: 'Login' }"
        >
          Login
        </router-link>
        <router-link
          v-if="!isLoggedIn"
          class="nav-item nav-link underlineHover"
          :to="{ name: 'Register' }"
        >
          Register
        </router-link>
        <router-link
          v-if="isLoggedIn"
          class="nav-item nav-link underlineHover"
          :to="{ name: 'Dashboard' }"
        >
          Dashboard
        </router-link>
        <a
          class="nav-item nav-link underlineHover"
          v-if="isLoggedIn"
          @click.prevent="logoutMethod"
          >Logout</a
        >
      </ul>
    </div>
  </nav>
</template>

<script>
//import Cookies from "js-cookie";
//import User from "../apis/User";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      isLoggedIn: false,
    };
  },
  mounted() {
    this.$root.$on("login", () => {
      this.isLoggedIn = true;
    });

    this.isLoggedIn =
      !!localStorage.getItem("auth") 
      //&& !!localStorage.getItem("login");
  },

  methods: {
    ...mapActions(["logout"]),
    logoutMethod() {
      this.logout().then(() => {
        localStorage.removeItem("auth");
        //localStorage.removeItem("login");
        this.isLoggedIn = false;
        this.$router.push({ name: "Home" });
      });
    },
  },
};
</script>

<style>
.router-link-exact-active {
  color: #51a1e8 !important;
  transition: all 0.25s;
}
/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #0a80e5;
  content: "";
  transition: width 0.2s;
}
.underlineHover:hover {
  color: #0d0d0d;
}
.underlineHover:hover:after {
  width: 100%;
}
</style>
